import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist. Return to Life Care and Wellness homepage." />
      <Header />

      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4 text-center max-w-2xl">
          <div
            className="text-9xl font-bold mb-4"
            style={{ color: '#AABC5A' }}
            data-testid="404-heading"
          >
            404
          </div>
          <h1
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: '#587740' }}
          >
            Page Not Found
          </h1>
          <p
            className="text-lg mb-10 leading-relaxed"
            style={{ color: '#5e5e5e' }}
          >
            Sorry, the page you're looking for doesn't exist or has been moved.
            Let us help you find what you need.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button
                size="lg"
                className="text-white text-base px-8 py-6 hover:opacity-90"
                style={{ backgroundColor: '#81b956' }}
                data-testid="404-home-btn"
              >
                <Home className="w-5 h-5 mr-2" />
                Back to Home
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                size="lg"
                variant="outline"
                className="text-base px-8 py-6 border-2"
                style={{ borderColor: '#81b956', color: '#81b956' }}
                data-testid="404-contact-btn"
              >
                Contact Us
              </Button>
            </Link>
          </div>

          <div className="mt-16 p-8 rounded-2xl" style={{ backgroundColor: '#f8f9fa' }}>
            <h2 className="text-xl font-bold mb-4" style={{ color: '#587740' }}>
              Popular Pages
            </h2>
            <div className="flex flex-wrap gap-3 justify-center">
              {[
                { label: 'About Us', to: '/about' },
                { label: 'Our Services', to: '/services/ndis-consulting' },
                { label: 'Blog', to: '/blogs' },
                { label: 'Make a Referral', to: '/make-a-referral' },
                { label: 'Contact', to: '/contact' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="px-4 py-2 rounded-full text-sm font-medium hover:opacity-80 transition-opacity"
                  style={{ backgroundColor: '#81b956', color: '#fff' }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
